import React, { useState, useEffect } from "react";
import api from "../../services/api";
const CardDivergences = ({
  name,
  percentage,
  number,
  client,
  type,
  location,
}) => {
  const [value, setValue] = useState();

  const get = async () => {
    if (client && type && location) {
      const response = await api.post("reason/dashboard", {
        reasonErrors: name,
        client: client,
        type: type,
        location: location,
      });

      if (response.status == 404) {
        return false;
      }

      setValue(response.data.percentage);
    } else if (client && type) {
      const response = await api.post("reason/dashboard", {
        reasonErrors: name,
        client: client,
        type: type,
      });

      if (response.status == 404) {
        return false;
      }

      setValue(response.data.percentage);
    } else if (client) {
      const response = await api.post("reason/dashboard", {
        reasonErrors: name,
        client: client,
      });

      if (response.status == 404) {
        return false;
      }

      setValue(response.data.percentage);
    } else {
      const response = await api.post("reason/dashboard", {
        reasonErrors: name,
      });

      if (response.status == 404) {
        return false;
      }

      setValue(response.data.percentage);
    }
  };

  useEffect(() => {
    get();
  }, [name]);

  return (
    value > 0 && (
      <>
        <div
          style={{ marginBottom: "27px", position: "relative", width: "450px" }}
        >
          <p className="textCardDivergences">{name}</p>
          <div class="progress" style={{ height: "16px", width: "90%" }}>
            <div
              class="progress-bar"
              role="progressbar"
              style={{ width: `${value}%`, background: "#123164" }}
              aria-valuenow={value}
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>

          <p className="textCountNumberCardDivergence">
            {value != undefined ? `${value}%` : "0%"}
          </p>
        </div>
      </>
    )
  );
};

export default CardDivergences;
